import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar.jsx";
import Footer from "./Footer.jsx";
import { useLamp } from "../contexts/LampContext.jsx";
import "./Layout.css";

export default function Layout({ children }) {
  const { isLampOn } = useLamp();
  const location = useLocation();

  // ✅ Only treat lampOff mode on Home page
  const isHome = location.pathname === "/";
  const isHomeLampOff = isHome && !isLampOn;

  return (
    <div className={`appShell ${isHomeLampOff ? "lampOff" : ""}`}>
      <a className="skipLink" href="#main">
        Skip to content
      </a>

      {/* ✅ Navbar should always render (even on refresh of /services etc.) */}
      {!isHomeLampOff && (
        <div className="navContainer">
          <Navbar />
        </div>
      )}

      <main id="main">{children}</main>

      {/* ✅ Footer should also hide ONLY when home lamp is off */}
      {!isHomeLampOff && <Footer />}
    </div>
  );
}
